import React from 'react';
import { motion } from 'framer-motion'

import { GetPlayer } from '../../hoc/Layout/Layout'


const variants = {
    init: {
        opacity: .7,
        scale: .8,
        x: '-50%',
        y: '-50%'
    },
    show: {
        opacity: 1,
        scale: 1,
        x: '-50%',
        y: '-50%',
        transition: {
            duration: .2
        }
    }
}

const Modal = ({component: Component}) => {
    const { setModal } = GetPlayer()


    return (
        <div className="modal">
            <div className="modal__bg" onClick={() => setModal(null)}></div>
            <motion.div
                variants={variants} initial="init" animate="show"
            className="modal__content">
               {Component}
            </motion.div>
        </div>
    );
}

export default Modal;
